import CustomerRoutes from '@/routes-customer';
import CypressRoutes from '@/routes-cypress';
import EmployeeRoutes from '@/routes-employee';

export const publicRoutes = [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "js/public" */ './views/authentication/authentication-show.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/login-via-email',
        component: () => import(/* webpackChunkName: "js/public" */ './views/authentication/authentication-logging-in-show.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/',
        redirect: '/dashboard',
    },
    {
        path: '/403',
        name: '403',
        component: () => import(/* webpackChunkName: "js/public" */ './views/system/403.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/503',
        name: '503',
        component: () => import(/* webpackChunkName: "js/public" */ './views/system/503.vue'),
        meta: {
            public: true,
        },
    },

    {
        path: '/vc3zrpnxzeqhxs7g/:branchId',
        component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/tank-counts/tank-count-screen.vue'),
        meta: {
            public: true,
        },
    },

    {
        path: '/j315171/job-screen',
        component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/jobs/job-screen.vue'),
        meta: {
            public: true,
        },
    },

    {
        path: '/chemical/s1i5g1r3uts',
        component: () => import(/* webpackChunkName: "js/plant" */ './views/employees/chemical/chemical-screen.vue'),
        meta: {
            public: true,
        },
    },

    {
        path: '/new-hires',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/new-hires.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/anniversaries',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/anniversaries.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/birthdays',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/birthdays.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/employees-board',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/employees.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/employees-board/:employee_slug',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/employee-show.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/values-awards-board',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/values-award.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/p-sign-:id',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/proposal-sign.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/p-:id',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/proposal-billing.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/thank-you',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/proposal-thank-you.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/confirm-purchase-order/:purchaseOrderHash',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/confirm-purchase-order.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/purchase-order-confirmation-thank-you',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/purchase-order-confirmation-thank-you.vue'),
        meta: {
            public: true,
        },
    },
    {
        path: '/oxnard-miles',
        component: () => import(/* webpackChunkName: "js/public" */ './views/public/oxnard-miles.vue'),
        meta: {
            public: true,
        },
    },
];

export default [
    CustomerRoutes,
    EmployeeRoutes,
    publicRoutes,
];

export const getRoutesFromUserType = (type, xlinxFeatureManager) => {
    let routes = [];

    if (type === 'customer') {
        routes = CustomerRoutes;
    } else if (type === 'employee') {
        routes = EmployeeRoutes;
    }

    const cypressRoutes = process.env.NODE_ENV !== 'production' ? CypressRoutes : [];

    routes = routes.filter(async (route) => {
        if (route?.meta?.featureName) {
            return xlinxFeatureManager.enabled(route.meta.featureName);
        }
        return true;
    });

    return [...routes, ...cypressRoutes];
};
